import React from "react";

const ErrorAlert = ({ msg }) => (
    <div style={{ textAlign: "center" }} className="alert alert-danger" role="alert">
        {msg}
    </div>
);

export default ErrorAlert;